<script setup lang="ts">
import { useSidebar } from '../ui/sidebar/utils'
import { useAuthStore } from '~/store/authStore'

const localePath = useLocalePath()

const user = await useAuthStore().getUser()
const route = useRoute()
const { isMobile } = useSidebar()
</script>

<template>
  <UiTabs
    :default-value="route.path"
    :orientation="isMobile ? 'vertical' : 'horizontal'"
  >
    <UiTabsList>
      <UiTabsTrigger
        :value="localePath('/play/training')"
        as-child
      >
        <NuxtLink :to="localePath('/play/training')">
          {{ $t('Dashboard') }}
        </NuxtLink>
      </UiTabsTrigger>
      <UiTabsTrigger
        :value="localePath('/play/training/games')"
        as-child
      >
        <NuxtLink :to="localePath('/play/training/games')">
          {{ $t('Training games') }}
        </NuxtLink>
      </UiTabsTrigger>
      <UiTabsTrigger
        :value="localePath('/play/training/stats')"
        as-child
      >
        <NuxtLink :to="localePath('/play/training/stats')">
          {{ $t('Training stats') }}
        </NuxtLink>
      </UiTabsTrigger>
      <UiTabsTrigger
        v-if="user?.is_coach"
        :value="localePath('/play/training/coaching/my-students')"
        as-child
      >
        <NuxtLink :to="localePath('/play/training/coaching/my-students')">
          {{ $t('My students') }}
        </NuxtLink>
      </UiTabsTrigger>
      <UiTabsTrigger
        v-if="user?.coached_by"
        :value="localePath('/play/training/coaching/my-coach')"
        as-child
      >
        <NuxtLink :to="localePath('/play/training/coaching/my-coach')">
          {{ $t('My coach') }}
        </NuxtLink>
      </UiTabsTrigger>
    </UiTabsList>
  </UiTabs>
</template>
